// deployment_class: customer_env_allowed
/**
 * NotFound — 404 page (per Plan 14 §Task 10 + Spec 12 §4.2 + §8.1).
 *
 * Also the rendering target for `RequireOrgMembership` when a user attempts
 * to access a tenant-scoped URL they're not a member of (Spec 12 §4.2 —
 * 404, NOT 403, to avoid existence leaks).
 */
import { Link } from 'react-router-dom';

export function NotFound(): JSX.Element {
  return (
    <div className="min-h-screen bg-paper text-ink p-page">
      <div className="max-w-prose">
        <p className="font-body text-label uppercase text-warm-gray-d">404</p>
        <h1 className="font-display text-display-1 mt-2">Page not found.</h1>
        <p className="mt-rhythm text-body-l text-warm-gray-d">
          The page you&rsquo;re looking for doesn&rsquo;t exist or you don&rsquo;t
          have access to it.
        </p>
        <Link
          to="/marketplace"
          className="mt-rhythm inline-block text-trust underline underline-offset-2"
        >
          Browse the Marketplace
        </Link>
      </div>
    </div>
  );
}
